/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.cartElement = document.querySelector('cart-form');
    this.submitButton = this.querySelector('[type="submit"]');
    this.qtyInput = this.querySelector('[data-qty-input]');
    this.variantSelects = this.querySelector('variant-selects');
    this.headerId = document.querySelector('.section-header').querySelector('[data-section-id]').dataset.sectionId;
  }

  connectedCallback() {
    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  updateProductDetails(container, variant) {
    (variant == false) ? this.toggleAddButton('disable') : this.toggleAddButton('enable', variant.available, variant.price);
    if(variant){
      this.updateURLandID(variant);
      this.priceUpdate(container, variant);
      this.updateImage(container, variant.featured_media);

      const selectedOptions = container.querySelector('[data-product-selected-options]');
      const optionPickers = container.querySelectorAll('[data-product-option-picker]');
      const ringSizePicker = container.querySelector('select.ring-form-select');

      if(selectedOptions){
        let selectedOptionsHTML = '';
        optionPickers.forEach(picker => {
          const pickerValue = picker.querySelector('[data-selected-option-label]');
          if(pickerValue){
            selectedOptionsHTML += `<p>${pickerValue.innerHTML}</p>`;
          }
        });
        selectedOptionsHTML += (ringSizePicker?.value) ? `<p>Ring Size(US): <span class="selected-option fw-medium">${ringSizePicker.value}</span></p>` : '';
        selectedOptions.innerHTML = selectedOptionsHTML; 
      }
    }
  }

  /**
   * Render Price details based on current variant
   */
   priceUpdate(container,variant){
    const priceElement = container.querySelector('[data-currentPrice]');
    if(!priceElement) return;
    
    const comparePriceElement = container.querySelector('[data-comparePrice]');
    priceElement.innerHTML = Utility.formatMoney(variant.price, window.globalSpace.money_format);
    // console.log(Utility.formatMoney(variant.price, window.globalSpace.money_format));
    if (comparePriceElement) {
      comparePriceElement.innerHTML = Utility.formatMoney(variant.compare_at_price, window.globalSpace.money_format);
      comparePriceElement.classList.toggle('d-none', !variant.compare_at_price || variant.compare_at_price <= 0 || variant.compare_at_price === variant.price);
    }
  }

  /**
     * Toggle the button based on product availability ( add to cart / soldOut )
     * @param {Text} status enable / disable
     * @param {Boolean} variantAvailable true/false
     * @param {Number} price in cents
     */
   toggleAddButton(status, variantAvailable, price) {
    if (!this.submitButton) return;

    const addText = this.submitButton.querySelector('.add-text');
    if(!addText) return;
    
    if (status === 'disable') {
      addText.textContent = window.variantStrings.addToCart;
    } else if (!variantAvailable) {
        this.submitButton.setAttribute('disabled', true);
        addText.textContent = window.variantStrings.soldOut;
    } else {
        this.submitButton.removeAttribute('disabled');
        addText.innerHTML = this.form.classList.contains('cart-upsell-form') ? window.variantStrings.upsellAddText : `${window.variantStrings.addToCart} - ${Utility.formatMoney(price, window.globalSpace.money_format)}`;
    }
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant || !this.form) return;

    // if (this.dataset.format === 'product-page') window.history.replaceState({}, '', `${this.form.dataset.url}?variant=${currentVariant.id}`);
    this.form.querySelector('input[name="id"]').value = currentVariant.id;
  }

  /**
   * Render selected variant image/slide
   * @param {element} container
   * @param {object} variantMedia
   */
  updateImage(container, variantMedia) {
    if(!variantMedia) return;

    const imgElem = container.querySelector('[data-feauredImage]');
    const imageSlide = container.querySelector(`[data-productSlider] [data-mediaID="${variantMedia.id}"]`);
    if (imgElem && variantMedia.preview_image.src) {
      imgElem.removeAttribute('srcset');
      imgElem.src = variantMedia.preview_image.src;
    } else if(imageSlide) {
      const slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      container.querySelector('[data-productSlider]').swiper.slideTo(slideIndex, 0, false);
    }
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();

    // Validate variant options before proceeding
    if (this.variantSelects && !this.variantSelects.validateOptions()) {
      return;
    }

    const addItems = [];
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');

    addItems.push(Utility.serializeForm(this.form));
    let cartSectionID = 'component-cart-drawer';
    if(window.globalSpace.template == 'cart'){
      cartSectionID = document.getElementById('cart--items')?.dataset.id || 'template-cart';
    }

    const body = JSON.stringify({
      items: addItems,
      sections: `${cartSectionID}` 
    });

    fetch(`${routes.cart_add_url}`, { ...Utility.fetchConfig(), body })
    .then((response) => response.json())
    .then((res) => {
      const dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
      if(dataJSON.errors){
        window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
          type: 'error',
          timeout: 5000
        });
        return;
      }
      let cartSection = dataJSON.sections[`${cartSectionID}`];
      this._klavitoATC(cartSection);

      eventBus.publish(PUB_SUB_EVENTS.productATC, {
        data: {
          item: dataJSON.items[0]
        },
      });
      document.querySelector('#PopupModal-quickshop .close-quickshop')?.dispatchEvent(new Event('click'))

      if(this.qtyInput) this.qtyInput.value = 1;
      if(this.cartElement){
        this.cartElement?._updateCart(dataJSON.sections, this.submitButton);
      }else{
        window.location.href = window.routes.cart_fetch_url;
      }
    })
    .catch((e) => {
      window.notificationEle.updateNotification('Error', e, {
        type: 'error',
        timeout: 5000
      });
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');
    });
  }

  _klavitoATC(cartSection) {
    let _learnq = window._learnq || [];
    
    let parser = new DOMParser();
    let cartHTML = parser.parseFromString(cartSection, 'text/html');
    let cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');
    let cart_json = JSON.parse(cartJSONEle.textContent);

    let cart = {
      total_price: cart_json.total_price/100,
      $value: cart_json.total_price/100,
      total_discount: cart_json.total_discount,
      original_total_price: cart_json.original_total_price/100,
      items: cart_json.items
    }
    _learnq.push(['track', 'Added to Cart', cart]);
    console.log(_learnq);
  }
}
customElements.define('product-form', ProductForm);
